export const PROPERTY_TYPE_IDENTITY = {
    label: 'Property type',
    definition: 'Primary building use associated with an NCC building class.',
    citationLabel: 'NCC classifications',
    citationUrl:
        'https://ncc.abcb.gov.au/ncc-navigator/building-classifications',
    source: 'user',
} as const;

export const SUB_PREMISE_TYPE_IDENTITY = {
    label: 'Sub-premise type',
    definition:
        'Type of separately identifiable portion within a building or complex.',
    citationLabel: 'Geoscape G-NAF',
    citationUrl:
        'https://docs.geoscape.com.au/projects/gnaf_desc/en/stable/appendix_c.html#flat-type-aut',
    source: 'geoscape',
    sourceDescription: 'This value is provided by Geoscape.',
} as const;
